import Text, { TEXT_VARIANT } from '@pixum/text';
import styles from './CartPayPalExpressHint.module.css';

interface CartPayPalExpressHintProps {
  title: string;
  text: string;
}

export function CartPayPalExpressHint({ title, text }: CartPayPalExpressHintProps) {
  // Missing CMS keys would otherwise render an empty box.
  if (!title && !text) return null;

  return (
    <div className={styles.hint} role="status">
      <div className={styles.content}>
        <Text variant={TEXT_VARIANT.HEADLINE}>{title}</Text>
        <Text variant={TEXT_VARIANT.BODY}>{text}</Text>
      </div>
    </div>
  );
}
